(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 75511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(21742);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ submitRegisterForm; },
/* harmony export */   "_": function() { return /* binding */ checkUidConfirm; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48106);
/* harmony import */ var _common_cookieOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62049);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var checkUidConfirm = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var response, status, _data, Code, Data;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_4__/* ["default"].MEMBER */ .Z.MEMBER).post(body);
                case 2:
                    response = _ctx.sent;
                    status = response.status;
                    _data = response.data, Code = _data.Code, Data = _data.Data;
                    if (!(status === 200)) {
                        _ctx.next = 14;
                        break;
                    }
                    if (!(Code === "0000")) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", response.data);
                case 10:
                    if (!(Code === "9999")) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", response.data);
                case 12:
                    _ctx.next = 15;
                    break;
                case 14:
                    return _ctx.abrupt("return", console.log("\uC815\uC0C1\uC801\uC778 \uC694\uCCAD\uC774 \uC544\uB2D9\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkUidConfirm(body) {
        return _ref.apply(this, arguments);
    };
}();
var submitRegisterForm = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var response, status, _data, Code, Data;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_4__/* ["default"].MEMBER */ .Z.MEMBER).post(body);
                case 2:
                    response = _ctx.sent;
                    status = response.status;
                    _data = response.data, Code = _data.Code, Data = _data.Data;
                    if (!(status === 200)) {
                        _ctx.next = 15;
                        break;
                    }
                    if (!(Code === "0000")) {
                        _ctx.next = 11;
                        break;
                    }
                    (0,_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .setCookie */ .d8)("token", Data.token, _common_cookieOptions__WEBPACK_IMPORTED_MODULE_2__/* .authCookie */ .Z);
                    return _ctx.abrupt("return", "Success");
                case 11:
                    if (!(Code === "9999")) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", Data.Msg);
                case 13:
                    _ctx.next = 16;
                    break;
                case 15:
                    return _ctx.abrupt("return", console.log("\uC815\uC0C1\uC801\uC778 \uC694\uCCAD\uC774 \uC544\uB2D9\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitRegisterForm(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 31816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ cerPhoneNumberCheck; },
/* harmony export */   "k": function() { return /* binding */ cerPhoneTokenCheck; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 회원 본인 인증
var cerPhoneNumberCheck = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].CERTIFICATION */ .Z.CERTIFICATION).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.Data
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cerPhoneNumberCheck(body) {
        return _ref.apply(this, arguments);
    };
}();
// 인증번호 검증
var cerPhoneTokenCheck = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].CERTIFICATION */ .Z.CERTIFICATION).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.Data
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cerPhoneTokenCheck(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 62049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ uidCookie; },
/* harmony export */   "Z": function() { return /* binding */ authCookie; }
/* harmony export */ });
/*
- attributes

expires: 만료 기간 (date)

maxAge: 클라이언트가 쿠키를 수신한 시점부터 쿠키의 상대적인 최대 수명 (sec)

secure: 웹 브라우저와 웹 서버가 https로 통신하는 경우에만 쿠키 저장

httpOnly: document.cookie라는 자바스크립트 코드로 쿠키에 비정상적으로 접속하는 것을 막는 옵션
*/ var authCookie = {
    sameSite: "strict",
    path: "/"
};
var uidCookie = {
    sameSite: "strict",
    path: "/",
    maxAge: 2592000
};


/***/ }),

/***/ 89126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ evidenceCheck; },
/* harmony export */   "v": function() { return /* binding */ autoPhoneFormat; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var autoPhoneFormat = function(phoneNumber) {
    if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(0, 2)) == "02") {
        var value = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        return value;
    } else {
        var value1 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        return value1;
    }
};
var evidenceCheck = function(insertNum) {
    var regsplitNum = insertNum.replace(/-/gi, "").split("").map(function(item) {
        return parseInt(item, 10);
    });
    if (regsplitNum.length === 10) {
        var regkey = [
            1,
            3,
            7,
            1,
            3,
            7,
            1,
            3,
            5
        ];
        var regNumSum = 0;
        for(var i = 0; i < regkey.length; i++){
            regNumSum += regkey[i] * regsplitNum[i];
        }
        regNumSum += parseInt(regkey[8] * regsplitNum[8] / 10, 10);
        var regCheck = Math.floor(regsplitNum[9]) === (10 - regNumSum % 10) % 10;
        return regCheck;
    }
};


/***/ }),

/***/ 10103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FB": function() { return /* binding */ registerValidationSchema; },
/* harmony export */   "JW": function() { return /* binding */ GPTypeTwoSchema; },
/* harmony export */   "Ly": function() { return /* binding */ GPTypeFourSchema; },
/* harmony export */   "Nd": function() { return /* binding */ findIdValidationSchema; },
/* harmony export */   "UT": function() { return /* binding */ findPwValidationSchema; },
/* harmony export */   "gW": function() { return /* binding */ GPTypeThirdSchema; },
/* harmony export */   "i1": function() { return /* binding */ findPwReqValidationSchema; },
/* harmony export */   "lI": function() { return /* binding */ GPTypeOneSchema; },
/* harmony export */   "te": function() { return /* binding */ findIdReqValidationSchema; },
/* harmony export */   "zq": function() { return /* binding */ editUserInfoValidationSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var registerValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(6, "6\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    upass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()// .length(8, "8자 이상 입력해주세요.")
    .matches(/^.{8,}$/, "\uCD5C\uC18C 8\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    reupass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().oneOf([
        yup__WEBPACK_IMPORTED_MODULE_0__/* .ref */ .iH("upass")
    ], "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.").required("\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC774\uBA54\uC77C \uD615\uC2DD\uC744 \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var editUserInfoValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(6, "6\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC774\uBA54\uC77C \uD615\uC2DD\uC744 \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findPwValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uB4F1\uB85D\uD55C \uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findPwReqValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    num: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^([0-9]{6})$/, "\uC778\uC99D\uBC88\uD638 \uC22B\uC790 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC778\uC99D\uBC88\uD638 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    upass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^.{8,}$/, "\uCD5C\uC18C 8\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uB4F1\uB85D\uD560 \uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    reupass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().oneOf([
        yup__WEBPACK_IMPORTED_MODULE_0__/* .ref */ .iH("upass"),
        null
    ], "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.").required("\uB3D9\uC77C\uD55C \uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findIdValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB4F1\uB85D\uD55C \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findIdReqValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    num: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^([0-9]{6})$/, "\uC778\uC99D\uBC88\uD638 \uC22B\uC790 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC778\uC99D\uBC88\uD638 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var GPTypeOneSchema = function(param) {
    var min = param.min, rounding = param.rounding, max = param.max;
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
        cnt: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("\uC8FC\uBB38 \uC218\uB7C9\uC740 \uD544\uC218 \uC785\uB2C8\uB2E4.").transform(function(value, originalValue) {
            return isNaN(originalValue) ? undefined : Number(originalValue);
        }).test("roundTest", "\uBB36\uC74C \uB2E8\uC704\uB97C \uD655\uC778\uD558\uC138\uC694", function(value, context) {
            var check = true;
            if (value % rounding) {
                check = false;
            }
            if (!check) {
                return context.createError({
                    path: context.path,
                    message: "".concat(rounding, " \uB2E8\uC704\uB85C \uC8FC\uBB38 \uAC00\uB2A5\uD569\uB2C8\uB2E4.")
                });
            }
            return check;
        }).test("is-not-nan", "\uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.", function(value) {
            return !isNaN(value);
        }).min(min || 500, "\uCD5C\uC18C \uC8FC\uBB38 \uC218\uB7C9\uC740 ".concat(min || 500, "\uAC1C \uC785\uB2C8\uB2E4.")).max(max || 9999999, "\uCD5C\uB300 \uC8FC\uBB38 \uC218\uB7C9\uC740 ".concat(max || 99999999, "\uAC1C \uC785\uB2C8\uB2E4.")),
        company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5C5\uCCB4\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB2F4\uB2F9\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
        email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        doro_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC8FC\uC18C \uD544\uC218\uC785\uB2C8\uB2E4."),
        detail_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC0C1\uC138\uC8FC\uC18C\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
        editYn: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB514\uC790\uC778 \uC791\uC5C5 \uC120\uD0DD\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
        file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
            if (!value) return false; // 파일이 없는 경우
            if (Object.prototype.toString.call(value) === "[object File]") {
                return Object.prototype.toString.call(value) === "[object File]";
            } else {
                return Object.prototype.toString.call(value) === "[object FileList]";
            }
        })
    });
};
var GPTypeTwoSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    cnt: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().transform(function(value, originalValue) {
        return isNaN(originalValue) ? undefined : Number(originalValue);
    }).test("is-not-nan", "\uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.", function(value) {
        return !isNaN(value);
    }).required("\uAD50\uC721 \uCC38\uAC00 \uC778\uC6D0\uC740 \uD544\uC218 \uC785\uB2C8\uB2E4.").min(1, "\uCD5C\uC18C \uCC38\uAC00 \uC778\uC6D0\uC740 1\uBA85 \uC785\uB2C8\uB2E4."),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});
var GPTypeThirdSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4.").required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uBB38\uC758 \uB0B4\uC6A9\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
        if (!value) return false; // 파일이 없는 경우
        if (Object.prototype.toString.call(value) === "[object File]") {
            return Object.prototype.toString.call(value) === "[object File]";
        } else {
            return Object.prototype.toString.call(value) === "[object FileList]";
        }
    }),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});
var GPTypeFourSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4.").required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uBB38\uC758 \uB0B4\uC6A9\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
        if (!value) return false; // 파일이 없는 경우
        if (Object.prototype.toString.call(value) === "[object File]") {
            return Object.prototype.toString.call(value) === "[object File]";
        } else {
            return Object.prototype.toString.call(value) === "[object FileList]";
        }
    }),
    doro_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC8FC\uC18C \uD544\uC218\uC785\uB2C8\uB2E4."),
    detail_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC0C1\uC138\uC8FC\uC18C\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});


/***/ }),

/***/ 20089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pages_privacy_policy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13130);
/* harmony import */ var _pages_store_policy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9135);
/* harmony import */ var _mypage_myAddress_MyAddress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51839);
/* harmony import */ var _mypage_myAddress_MyAddress_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10372);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19433);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75146);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12053);









var PolicyModal = function(param) {
    var setOpenPolicyModal = param.setOpenPolicyModal, openPolicyModal = param.openPolicyModal, policy = param.policy;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return setOpenPolicyModal(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            show: true,
            size: "lg",
            onHide: function() {
                return setOpenPolicyModal(false);
            },
            scrollable: true,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                        children: [
                            " ",
                            policy == 0 ? "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68" : "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uC774\uC6A9\uC57D\uAD00"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: policy == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_privacy_policy__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        isModal: true
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_store_policy__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        isModal: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PolicyModal);


/***/ }),

/***/ 10372:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _common_postcode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74547);
/* harmony import */ var _map_Maptainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(590);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 31;\n  width: 100vw;\n  height: 100vh;\n\n  .modal-section {\n    position: fixed;\n    top: 54%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    border-radius: 20px;\n    width: 35rem;\n    overflow-x: hidden;\n    z-index: 32;\n    border: none;\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      position: fixed;\n      top: 3%;\n      right: 3%;\n      z-index: 33;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n\n    @media (max-width: 960px) {\n      width: 90%;\n    }\n  }\n\n  .modal-header {\n    width: 100%;\n    margin-top: 1rem;\n    padding-left: 2rem;\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: black;\n  }\n\n  .modal-content {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    border: none;\n    overflow-y: auto;\n    & span {\n      color: black;\n    }\n    z-index: 33;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  padding-right: 5%;\n  padding-bottom: 1rem;\n  padding-left: 5%;\n  display: flex;\n  align-items: center;\n\n  .zipcode {\n    width: 39%;\n  }\n\n  .btn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    width: 30%;\n    height: 38px;\n    margin-left: 1%;\n    word-break: keep-all;\n    border-radius: 10px;\n  }\n\n  @media (max-width: 960px) {\n    width: 100%;\n    border: 0;\n    margin-right: 0;\n  }\n\n  & h6 {\n    display: flex;\n    align-items: center;\n    width: 30%;\n    font-weight: 400;\n    margin-bottom: 10px;\n  }\n\n  & input {\n    width: 70%;\n    height: 2.3rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 3rem;\n  display: flex;\n  justify-content: center;\n\n  & button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c02d513a-0"
})(_templateObject());
var ModalContentRow = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c02d513a-1"
})(_templateObject1());
var ModalContentCol = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c02d513a-2"
})(_templateObject2());
var ComfirmBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c02d513a-3"
})(_templateObject3());
var AddressModal = function(props) {
    var ref = useState(false), postOpen = ref[0], setPostOpen = ref[1];
    var ref1 = useState({
        address: ""
    }), pickAddress = ref1[0], setPickAddress = ref1[1];
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return props.setIsOpen(false);
    };
    // 우편번호 검색
    var handlePostModal = function() {
        setPostOpen(function(prev) {
            return !prev;
        });
    };
    var onCompleteAddressCode = function(postcode) {
        setPickAddress(postcode);
        props.reset({
            zipcode: postcode.zonecode
        });
        props.reset({
            doro_addr: pickAddress.roadAddress ? pickAddress.roadAddress : pickAddress.autoRoadAddress
        });
        props.reset({
            base_addr: pickAddress.jibunAddress ? pickAddress.jibunAddress : pickAddress.autoJibunAddress
        });
        setPostOpen(false);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalWrapper, {
                children: /*#__PURE__*/ _jsx("form", {
                    onSubmit: props.handleSubmit(function(data) {
                        return props.createAddress(data);
                    }),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "modal-section",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "modal-header",
                                children: "\uBC30\uC1A1\uC9C0 \uB4F1\uB85D"
                            }),
                            /*#__PURE__*/ _jsx("i", {
                                className: "fi-rs-cross-circle",
                                onClick: function() {
                                    return props === null || props === void 0 ? void 0 : props.setIsOpen(false);
                                }
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "modal-content",
                                children: [
                                    /*#__PURE__*/ _jsxs(ModalContentRow, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(ModalContentCol, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h6", {
                                                        children: "\uBC30\uC1A1\uC9C0 \uC774\uB984"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", _objectSpread({
                                                        type: "text"
                                                    }, props.register("addr_name")))
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ModalContentCol, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h6", {
                                                        children: "\uC6B0\uD3B8\uBC88\uD638"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", _objectSpread({
                                                        className: "zipcode",
                                                        type: "text",
                                                        readOnly: true,
                                                        defaultValue: pickAddress.zonecode
                                                    }, props.register("zipcode"))),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "btn",
                                                        onClick: handlePostModal,
                                                        children: "\uC8FC\uC18C \uAC80\uC0C9"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ModalContentCol, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h6", {
                                                        children: "\uB3C4\uB85C\uBA85 \uC8FC\uC18C"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", _objectSpread({
                                                        type: "text",
                                                        readOnly: true,
                                                        defaultValue: pickAddress.roadAddress ? pickAddress.roadAddress : pickAddress.autoRoadAddress
                                                    }, props.register("doro_addr")))
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ModalContentCol, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h6", {
                                                        children: "\uC9C0\uBC88 \uC8FC\uC18C"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", _objectSpread({
                                                        type: "text",
                                                        readOnly: true,
                                                        defaultValue: pickAddress.jibunAddress ? pickAddress.jibunAddress : pickAddress.autoJibunAddress
                                                    }, props.register("base_addr")))
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ModalContentCol, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h6", {
                                                        children: "\uC0C1\uC138 \uC8FC\uC18C"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", _objectSpread({
                                                        type: "text",
                                                        placeholder: "\uC0C1\uC138\uC8FC\uC18C \uC785\uB825"
                                                    }, props.register("detail_addr")))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(ComfirmBtnWrapper, {
                                        children: /*#__PURE__*/ _jsx("button", {
                                            type: "submit",
                                            children: "\uB4F1\uB85D\uD558\uAE30"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            postOpen && /*#__PURE__*/ _jsx(PostCode, {
                onClickHandleModal: handlePostModal,
                onCompletePostCode: onCompleteAddressCode
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    diplay: "none"
                },
                children: /*#__PURE__*/ _jsx(KakaoMap, {
                    address: pickAddress.address,
                    setUserInputs: props.setMapInputs,
                    userinputs: props.mapInputs
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AddressModal)));


/***/ }),

/***/ 33750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCheckUser; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _api_getUserInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48934);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//유저 체크
var useCheckUser = function(param) {
    var isLoading = param.isLoading, isLoaded = param.isLoaded, setIsNotUser = param.setIsNotUser;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var checkUser = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isLoading();
                        _ctx.next = 3;
                        return (0,_api_getUserInfo__WEBPACK_IMPORTED_MODULE_2__/* .getUserInfo */ .bG)();
                    case 3:
                        res = _ctx.sent;
                        if (res.code === "0000") {
                            isLoaded();
                            router.push("/");
                        }
                        if (res.code !== "0000") {
                            setIsNotUser(true);
                            isLoaded();
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkUser() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        checkUser: checkUser
    };
};


/***/ }),

/***/ 21742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./redux/action/modal.js
var modal = __webpack_require__(62241);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/alert.js
var action_alert = __webpack_require__(4557);
// EXTERNAL MODULE: ./common/validation.js
var validation = __webpack_require__(10103);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/confirm.js
var common_confirm = __webpack_require__(13203);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./api/Register.js
var Register = __webpack_require__(83272);
// EXTERNAL MODULE: ./components/checkout/policyModal.js
var policyModal = __webpack_require__(20089);
// EXTERNAL MODULE: ./api/getUserInfo.js + 1 modules
var getUserInfo = __webpack_require__(48934);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/register/register.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n\n  .inputWrapper {\n    width: 75%;\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: 70%;\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: 70%;\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: 65%;\n    }\n  }\n\n  button {\n    width: calc(100% - 79%);\n\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: calc(100% - 74%);\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: calc(100% - 74%);\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: calc(100% - 69%);\n    }\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n\n  .input-invalid-red {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-red:focus {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-msg {\n    padding-top: 1px;\n    padding-left: 0.3rem;\n    color: #c10000;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n\n  .pwInputWrapper {\n    width: 48%;\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n\n  .input-invalid-red {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-red:focus {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-msg {\n    padding-top: 1px;\n    padding-left: 0.3rem;\n    color: #c10000;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n\n  .nameInputWrapper {\n    width: 28%;\n  }\n\n  .emailInputWrapper {\n    width: 68%;\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n\n  .input-invalid-red {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-red:focus {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-msg {\n    padding-top: 1px;\n    padding-left: 0.3rem;\n    color: #c10000;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n\n  .inputBtnWrapper {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .inputWrapper,\n  .isConfirmed > input {\n    color: #b6b6b6;\n    cursor: not-allowed;\n  }\n\n  .inputWrapper {\n    width: 70%;\n\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: 65%;\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: 68%;\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: 58%;\n    }\n  }\n\n  button {\n    width: calc(100% - 74%);\n\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: calc(100% - 69%);\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: calc(100% - 74%);\n      font-size: 12px;\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: calc(100% - 62%);\n      font-size: 12px;\n    }\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n\n  .input-invalid-red {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-red:focus {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-msg {\n    padding-top: 1px;\n    padding-left: 0.3rem;\n    color: #c10000;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n\n  .inputBtnWrapper {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .inputWrapper {\n    position: relative;\n    width: 70%;\n\n    .timeCounter {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 12px;\n      color: #c10000;\n    }\n\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: 65%;\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: 68%;\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: 58%;\n    }\n  }\n\n  button {\n    width: calc(100% - 74%);\n\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      width: calc(100% - 69%);\n    }\n\n    @media only screen and (min-width: 480px) and (max-width: 667px) {\n      width: calc(100% - 74%);\n    }\n\n    @media only screen and (max-width: 480px) {\n      width: calc(100% - 62%);\n    }\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n\n  .input-invalid-red {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-red:focus {\n    height: 50px;\n    border: 1px solid #c10000;\n  }\n\n  .input-invalid-msg {\n    padding-top: 1px;\n    padding-left: 0.3rem;\n    color: #c10000;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n\n  .infoWrapper {\n    display: flex;\n    /* justify-content: space-between; */\n    align-items: center;\n    font-size: 1rem;\n    word-break: keep-all;\n    margin-bottom: 10px;\n\n    .subTitle {\n      margin-right: 5px;\n    }\n\n    .example {\n      background-color: #b6b6b6;\n      padding: 3px;\n      border-radius: 10px;\n      color: #fff;\n      font-size: 0.8rem;\n      word-break: keep-all;\n\n      @media only screen and (min-width: 480px) and (max-width: 667px) {\n        font-size: 12px;\n      }\n\n      @media only screen and (max-width: 480px) {\n        font-size: 12px;\n      }\n    }\n  }\n\n  input {\n    width: 100%;\n    height: 64px;\n    border: 1px solid #ececec;\n    padding-left: 20px;\n    background: #fff;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .form-input {\n    height: 50px;\n  }\n\n  input:focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var IdWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-0"
})(_templateObject());
var PasswordWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-1"
})(_templateObject1());
var NameEmailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-2"
})(_templateObject2());
var PhoneWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-3"
})(_templateObject3());
var PhoneCheckedWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-4"
})(_templateObject4());
var UsagesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-122fcda1-5"
})(_templateObject5());

// EXTERNAL MODULE: ./common/util/checkout-validation.js
var checkout_validation = __webpack_require__(89126);
// EXTERNAL MODULE: ./api/certification.js
var certification = __webpack_require__(31816);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./hook/useCheckUser.js
var useCheckUser = __webpack_require__(33750);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./store/useBannerStore.js + 1 modules
var useBannerStore = __webpack_require__(95435);
;// CONCATENATED MODULE: ./pages/register.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


























function register_Register(param) {
    var _$openModal = param.openModal, _$modifyModal = param.modifyModal, _$showToastAlert = param.showToastAlert, _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$uidConfirm = param.uidConfirm, _$isLoading = param.isLoading, _$isLoaded = param.isLoaded, banners = param.banners;
    var ref20, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), bannerList = ref6.bannerList, _interview = ref6.interview, interview = _interview === void 0 ? [] : _interview;
    var ref7 = (0,react.useState)(false), isNotUser = ref7[0], setIsNotUser = ref7[1];
    var ref8 = (0,react.useState)(false), openPolicy = ref8[0], setOpenPolicy = ref8[1];
    var ref9 = (0,react.useState)(), policyDivision = ref9[0], setPolicyDivision = ref9[1];
    var ref10 = (0,react.useState)([
        false,
        false,
        false
    ]), isBoxChecked = ref10[0], setIsBoxChecked = ref10[1];
    var ref11 = (0,react.useState)(true), isConfirmBtnActive = ref11[0], setIsConfirmBtnActive = ref11[1];
    var ref12 = (0,react.useState)(""), prevUidInput = ref12[0], setPrevUidInput = ref12[1];
    var ref13 = (0,react.useState)(""), channelInfo = ref13[0], setChannelInfo = ref13[1];
    var ref14 = (0,react.useState)(false), isCheckedPhone = ref14[0], setIsCheckedPhone = ref14[1];
    var ref15 = (0,react.useState)(false), isCheckingPhone = ref15[0], setIsCheckingPhone = ref15[1];
    var ref16 = (0,react.useState)(false), isCheckingTime = ref16[0], setIsCheckingTime = ref16[1];
    var ref17 = (0,react.useState)(""), checkValidTime = ref17[0], setCheckValidTime = ref17[1];
    var ref18 = (0,react.useState)(""), interviewBanner = ref18[0], setInterviewBanner = ref18[1];
    var formOptions = {
        resolver: (0,yup/* yupResolver */.X)(validation/* registerValidationSchema */.FB),
        mode: "onChange"
    };
    var ref19 = (0,index_esm/* useForm */.cI)(formOptions), register = ref19.register, handleSubmit = ref19.handleSubmit, formState = ref19.formState, reset = ref19.reset, getValues = ref19.getValues, watch = ref19.watch;
    var currentInputValues1 = getValues();
    var errors = formState.errors;
    // 유저 체크
    var checkUser = (0,useCheckUser/* useCheckUser */.J)({
        isLoading: _$isLoading,
        isLoaded: _$isLoaded,
        setIsNotUser: setIsNotUser
    }).checkUser;
    // 약관 동의 체크
    var checkboxHandler = function(id) {
        return function(e) {
            var tempArr = _toConsumableArray(isBoxChecked);
            tempArr[id] = e.target.checked;
            setIsBoxChecked(tempArr);
        };
    };
    // 아이디 중복확인 API 핸들
    var uidDuplicationHandler = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(currentInputValues1.uid == "")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."));
                    case 2:
                        body = {
                            modes: "IdSearch",
                            uid: currentInputValues1.uid
                        };
                        if (!errors.uid) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return (0,Register/* checkUidConfirm */._)(body);
                    case 7:
                        response = _ctx.sent;
                        if (!(response.Code === "0000")) {
                            _ctx.next = 15;
                            break;
                        }
                        setPrevUidInput(currentInputValues1.uid);
                        setIsConfirmBtnActive(false);
                        _$modifyConfirmModal(_$uidConfirm(response.Data.Msg));
                        return _ctx.abrupt("return", _$openConfirmModal());
                    case 15:
                        _$modifyConfirmModal(_$uidConfirm("\uAE30\uC874 \uC544\uC774\uB514\uC640 \uAC19\uAC70\uB098 \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC5C6\uB294 \uC544\uC774\uB514 \uC785\uB2C8\uB2E4."));
                        return _ctx.abrupt("return", _$openConfirmModal());
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function uidDuplicationHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    // 아이디 중복확인 버튼 활성화 유무
    var isUidConfirmed = function() {
        if (watch("uid") !== prevUidInput) {
            setIsConfirmBtnActive(true);
        }
    };
    // 인증번호 타임 체크
    var checkValidTimer = function() {
        if (isCheckingTime) return;
        setIsCheckingTime(true);
        var time = 300;
        var timer = setInterval(function() {
            if (time >= 0) {
                var min = String(Math.floor(time / 60)).padStart(2, "0");
                var sec = String(time % 60).padStart(2, "0");
                setCheckValidTime(min + ":" + sec);
                time -= 1;
            } else {
                clearInterval(timer);
                setIsCheckingTime(false);
                setIsCheckingPhone(false);
            }
        }, 1000);
    };
    // 인증번호 발송
    var checkValidPhone = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(watch("phone") == "" || watch("phone").length == 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."));
                    case 2:
                        body = {
                            modes: "Citation",
                            phone: watch("phone")
                        };
                        _ctx.next = 5;
                        return (0,certification/* cerPhoneNumberCheck */.a)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setIsCheckingPhone(true);
                            checkValidTimer();
                        }
                        if ((data === null || data === void 0 ? void 0 : data.code) === "9999") {
                            (0,common_alert/* failAlert */.qh)("\uC778\uC99D\uBC88\uD638 \uBC1C\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkValidPhone() {
            return _ref.apply(this, arguments);
        };
    }();
    // 인증번호 검증
    var checkValidPhoneToken = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, data, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(watch("phoneToken") == undefined || watch("phoneToken").length != 6)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC778\uC99D\uBC88\uD638\uB97C \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694."));
                    case 2:
                        body = {
                            modes: "Check",
                            phone: watch("phone"),
                            num: watch("phoneToken")
                        };
                        _ctx.next = 5;
                        return (0,certification/* cerPhoneTokenCheck */.k)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.Msg);
                            setIsCheckingPhone(false);
                            setIsCheckedPhone(true);
                        }
                        if ((data === null || data === void 0 ? void 0 : data.code) === "9999") {
                            (0,common_alert/* failAlert */.qh)("\uC798\uBABB\uB41C \uC778\uC99D\uBC88\uD638\uC785\uB2C8\uB2E4");
                        }
                        if ((data === null || data === void 0 ? void 0 : data.code) === "9990") {
                            (0,common_alert/* failAlert */.qh)("\uB9CC\uB8CC\uB418\uC5C8\uAC70\uB098 \uC5C6\uB294 \uC778\uC99D\uCF54\uB4DC\uC785\uB2C8\uB2E4");
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkValidPhoneToken() {
            return _ref.apply(this, arguments);
        };
    }();
    // 약관동의 모달
    var showTermsModal = function(num) {
        setOpenPolicy(function(prev) {
            return !prev;
        });
        setPolicyDivision(num);
    };
    // 회원정보 제출
    var submitHandler = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var currentInputValues, body, response, ref, UserAgent, widerplanet_device, wptg_tagscript_vars, wcs_add, _nasa, _nasa;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isBoxChecked.includes(false)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", _$showToastAlert("\uD544\uC218 \uD56D\uBAA9\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.", common_alert/* failToSubmit */.PF));
                    case 4:
                        if (!(isConfirmBtnActive === true)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", _$showToastAlert("\uC544\uC774\uB514 \uC911\uBCF5\uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.", common_alert/* failToSubmit */.PF));
                    case 8:
                        if (!(isCheckedPhone === false)) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", _$showToastAlert("\uD734\uB300\uD3F0 \uC778\uC99D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.", common_alert/* failToSubmit */.PF));
                    case 10:
                        currentInputValues = getValues();
                        body = {
                            modes: "Join",
                            uid: currentInputValues.uid,
                            upass: currentInputValues.upass,
                            reupass: currentInputValues.reupass,
                            company: currentInputValues.company,
                            name: currentInputValues.name,
                            email: currentInputValues.email,
                            phone: watch("phone"),
                            aid: sessionStorage.getItem("channel") ? currentInputValues.aid : "",
                            usages: currentInputValues.usages
                        };
                        if (!(channelInfo && (!body.aid || body.aid === ""))) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC81C\uD734 \uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."));
                    case 14:
                        _$isLoading();
                        _ctx.next = 17;
                        return (0,Register/* submitRegisterForm */.C)(body);
                    case 17:
                        response = _ctx.sent;
                        if (!(response === "Success")) {
                            _ctx.next = 39;
                            break;
                        }
                        ;
                        _$showToastAlert("\uD68C\uC6D0\uAC00\uC785\uC5D0 \uC131\uACF5\uD558\uC600\uC2B5\uB2C8\uB2E4.", common_alert/* succeedToSubmit */.VJ);
                        // 채널톡 가입 이벤트
                        window.ChannelIO("track", "SignUp", {
                            name: body.name,
                            email: body.email
                        });
                        UserAgent = navigator.userAgent;
                        widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
                        wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
                        wptg_tagscript_vars.push(function() {
                            return {
                                wp_hcuid: "",
                                ti: "54644",
                                ty: "Join" /*트래킹태그 타입 */ ,
                                device: widerplanet_device /*디바이스 종류  (web 또는  mobile)*/ ,
                                items: [
                                    {
                                        i: "\uD68C\uC6D0 \uAC00\uC785" /*전환 식별 코드  (한글 , 영어 , 번호 , 공백 허용 )*/ ,
                                        t: "\uD68C\uC6D0 \uAC00\uC785" /*전환명  (한글 , 영어 , 번호 , 공백 허용 )*/ ,
                                        p: "1" /*전환가격  (전환 가격이 없을 경우 1로 설정 )*/ ,
                                        q: "1" /*전환수량  (전환 수량이 고정적으로 1개 이하일 경우 1로 설정 )*/ 
                                    }, 
                                ]
                            };
                        });
                        globalThis.dataLayer.push({
                            event: "sign_up"
                        });
                        (ref = globalThis.wptg_tagscript) === null || ref === void 0 ? void 0 : ref.exec();
                        if (!wcs_add) wcs_add = {};
                        wcs_add["wa"] = "s_53d3817a0ea3";
                        _nasa = {};
                        if (window.wcs) {
                            _nasa["cnv"] = wcs.cnv("2", "1");
                            wcs_do(_nasa);
                        }
                        _nasa = {};
                        // ENP 회원가입
                        window.CallMtm({
                            productName: "",
                            convType: "join",
                            click: ""
                        });
                        reset();
                        _$isLoaded();
                        return _ctx.abrupt("return", router.push("/"));
                    case 39:
                        _$isLoaded();
                        return _ctx.abrupt("return", _$showToastAlert(response, common_alert/* failToSubmit */.PF));
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkAlliance = function() {
        var info = sessionStorage.getItem("channelInfo");
        if (info) {
            setChannelInfo(info);
        }
    };
    (0,react.useEffect)(function() {
        console.log(window);
        setIsConfirmBtnActive(false);
        checkboxHandler();
        checkUser();
        checkAlliance();
    }, []);
    (0,react.useEffect)(function() {
        isUidConfirmed();
    }, [
        watch("uid")
    ]);
    (0,react.useEffect)(function() {
        if (interview) {
            setInterviewBanner(interview[(0,lodash.random)(0, interview.length - 1)]);
        }
    }, [
        bannerList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uD68C\uC6D0\uAC00\uC785",
            pageTitle: SeoMeta/* SeoMeta.signUp.title */.e.signUp.title,
            pageDesc: SeoMeta/* SeoMeta.signUp.description */.e.signUp.description,
            pageKeyword: SeoMeta/* SeoMeta.signUp.keywords */.e.signUp.keywords,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "page-content mt-50 pb-150",
                    children: isNotUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-6 pr-30 d-none d-lg-block",
                                            children: interviewBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "border-radius-15",
                                                src: interviewBanner === null || interviewBanner === void 0 ? void 0 : interviewBanner.P_FileUrl,
                                                alt: interviewBanner === null || interviewBanner === void 0 ? void 0 : interviewBanner.img_alt
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-6 col-md-10 m-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "login_wrap widget-taber-content background-white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "padding_eight_all bg-white",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "heading_s1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                className: "mb-30",
                                                                children: "\uD68C\uC6D0\uAC00\uC785"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                            onSubmit: handleSubmit(submitHandler),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mb-3",
                                                                    children: [
                                                                        channelInfo && (channelInfo === null || channelInfo === void 0 ? void 0 : channelInfo.split("+")[0]) != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "form-group",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                    required: "",
                                                                                    type: "text",
                                                                                    name: "aid",
                                                                                    placeholder: "".concat(channelInfo === null || channelInfo === void 0 ? void 0 : channelInfo.split("+")[0], " \uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
                                                                                }, register("aid"), {
                                                                                    className: "".concat(errors.aid ? "input-invalid-red" : "form-input")
                                                                                })),
                                                                                !watch("aid") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "input-invalid-msg",
                                                                                    children: "\uC81C\uD734 \uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(IdWrapper, {
                                                                            variable: "75",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "inputWrapper",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                        required: "",
                                                                                        type: "text",
                                                                                        name: "uid"
                                                                                    }, register("uid"), {
                                                                                        placeholder: "\uC544\uC774\uB514",
                                                                                        autoComplete: "off",
                                                                                        className: "".concat(errors.uid ? "input-invalid-red" : "form-input")
                                                                                    }))
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: uidDuplicationHandler,
                                                                                    className: "btn uid-confirmation-btn",
                                                                                    disabled: isConfirmBtnActive ? false : true,
                                                                                    children: "\uC911\uBCF5\uD655\uC778"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        errors.uid && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "input-invalid-msg",
                                                                            children: (ref20 = errors.uid) === null || ref20 === void 0 ? void 0 : ref20.message
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasswordWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "pwInputWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                    required: "",
                                                                                    type: "password",
                                                                                    name: "upass",
                                                                                    placeholder: "\uBE44\uBC00\uBC88\uD638"
                                                                                }, register("upass"), {
                                                                                    autoComplete: "new-password",
                                                                                    className: "".concat(errors.upass ? "input-invalid-red" : "form-input")
                                                                                })),
                                                                                errors.upass && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "input-invalid-msg",
                                                                                    children: (ref1 = errors.upass) === null || ref1 === void 0 ? void 0 : ref1.message
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "pwInputWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                    required: "",
                                                                                    type: "password",
                                                                                    name: "reupass",
                                                                                    placeholder: "\uBE44\uBC00\uBC88\uD638 \uD655\uC778"
                                                                                }, register("reupass"), {
                                                                                    autoComplete: "off",
                                                                                    className: "".concat(errors.reupass ? "input-invalid-red" : "form-input")
                                                                                })),
                                                                                errors.reupass && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "input-invalid-msg",
                                                                                    children: (ref2 = errors.reupass) === null || ref2 === void 0 ? void 0 : ref2.message
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "form-group",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                        // required=""
                                                                        type: "text",
                                                                        name: "company",
                                                                        placeholder: "\uD68C\uC0AC\uBA85(\uC120\uD0DD)"
                                                                    }, register("company"), {
                                                                        autoComplete: "off",
                                                                        className: "form-input"
                                                                    }))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameEmailWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "nameInputWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                    required: "",
                                                                                    type: "text",
                                                                                    name: "name",
                                                                                    placeholder: "\uB2F4\uB2F9\uC790\uBA85"
                                                                                }, register("name"), {
                                                                                    className: "".concat(errors.name ? "input-invalid-red" : "form-input")
                                                                                })),
                                                                                errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "input-invalid-msg",
                                                                                    children: (ref3 = errors.name) === null || ref3 === void 0 ? void 0 : ref3.message
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "emailInputWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                    required: "",
                                                                                    type: "email",
                                                                                    name: "email",
                                                                                    placeholder: "\uC774\uBA54\uC77C"
                                                                                }, register("email"), {
                                                                                    className: "".concat(errors.email ? "input-invalid-red" : "form-input")
                                                                                })),
                                                                                errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: "input-invalid-msg",
                                                                                    children: (ref4 = errors.email) === null || ref4 === void 0 ? void 0 : ref4.message
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhoneWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "inputBtnWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: isCheckedPhone === true || isCheckingPhone === true ? "inputWrapper isConfirmed" : "inputWrapper",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                        required: "",
                                                                                        type: "text",
                                                                                        name: "phone",
                                                                                        placeholder: "\uC5F0\uB77D\uCC98 (-\uB97C \uC81C\uC678\uD55C \uC22B\uC790\uB9CC)"
                                                                                    }, register("phone"), {
                                                                                        autoComplete: "off",
                                                                                        className: "".concat(errors.phone ? "input-invalid-red" : "form-input"),
                                                                                        maxLength: 13,
                                                                                        disabled: isCheckedPhone === true || isCheckingPhone === true ? true : false
                                                                                    }))
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: checkValidPhone,
                                                                                    className: "btn uid-confirmation-btn",
                                                                                    disabled: Boolean(errors.phone) === true || isCheckingPhone === true || isCheckedPhone === true ? true : false,
                                                                                    children: "\uC778\uC99D\uBC88\uD638 \uBC1C\uC1A1"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        errors.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "input-invalid-msg",
                                                                            children: (ref5 = errors.phone) === null || ref5 === void 0 ? void 0 : ref5.message
                                                                        })
                                                                    ]
                                                                }),
                                                                isCheckingPhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhoneCheckedWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "inputBtnWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "inputWrapper",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                                            required: "",
                                                                                            type: "text",
                                                                                            name: "phone",
                                                                                            placeholder: "\uC778\uC99D\uBC88\uD638 \uC785\uB825"
                                                                                        }, register("phoneToken"), {
                                                                                            autoComplete: "off",
                                                                                            className: "form-input",
                                                                                            maxLength: 6
                                                                                        })),
                                                                                        isCheckingPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "timeCounter",
                                                                                            children: checkValidTime
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: checkValidPhoneToken,
                                                                                    className: "btn uid-confirmation-btn",
                                                                                    children: "\uC778\uC99D\uD558\uAE30"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: "\uC778\uC99D\uBC88\uD638\uB294 \uCE74\uCE74\uC624 \uC54C\uB9BC\uD1A1 \uD639\uC740 \uBB38\uC790\uB85C \uC804\uC1A1\uB429\uB2C8\uB2E4."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UsagesWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "infoWrapper",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "subTitle",
                                                                                    children: "\uD3EC\uC7A5\uD558\uC2DC\uB294 \uC0C1\uD488 \uC815\uBCF4(\uC120\uD0DD)"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "example",
                                                                                    children: "\uC608\uC2DC) \uD654\uC7A5\uD488, \uC758\uB958"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                                                            // required=""
                                                                            type: "text",
                                                                            name: "phone"
                                                                        }, register("usages"), {
                                                                            autoComplete: "off",
                                                                            className: "form-input"
                                                                        }))
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "login_footer form-group",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "chek-form",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "custome-checkbox d-flex align-itmes-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                    className: "form-check-input",
                                                                                    type: "checkbox",
                                                                                    name: "checkbox",
                                                                                    id: "terms-agreement-0",
                                                                                    value: "",
                                                                                    checked: isBoxChecked[0],
                                                                                    onChange: checkboxHandler(0)
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                    className: "form-check-label",
                                                                                    htmlFor: "terms-agreement-0",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "(\uD544\uC218) \uB9CC 14\uC138 \uC774\uC0C1 \uB3D9\uC758"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "login_footer form-group",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "chek-form",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "custome-checkbox d-flex align-itmes-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "checkbox",
                                                                                        name: "checkbox",
                                                                                        id: "terms-agreement-1",
                                                                                        value: "",
                                                                                        checked: isBoxChecked[1],
                                                                                        onChange: checkboxHandler(1)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "terms-agreement-1",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: "(\uD544\uC218) \uC774\uC6A9\uC57D\uAD00 \uB3D9\uC758"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            type: "button",
                                                                            onClick: function() {
                                                                                return showTermsModal(1);
                                                                            },
                                                                            className: "register-agreement-btn d-flex align-items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-book-alt mr-5 text-muted"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "text-muted",
                                                                                    children: "\uC57D\uAD00\uBCF4\uAE30"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "login_footer form-group mb-50",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "chek-form",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "custome-checkbox d-flex align-itmes-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "checkbox",
                                                                                        name: "checkbox",
                                                                                        id: "terms-agreement-2",
                                                                                        value: "",
                                                                                        checked: isBoxChecked[2],
                                                                                        onChange: checkboxHandler(2)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "terms-agreement-2",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: "(\uD544\uC218) \uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1 \uC774\uC6A9\uB3D9\uC758"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            type: "button",
                                                                            onClick: function() {
                                                                                return showTermsModal(0);
                                                                            },
                                                                            className: "register-agreement-btn d-flex align-items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-book-alt mr-5 text-muted"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "text-muted",
                                                                                    children: "\uC57D\uAD00\uBCF4\uAE30"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "form-group",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "submit",
                                                                        className: "btn btn-heading btn-block hover-up col-12",
                                                                        name: "login",
                                                                        children: "\uD68C\uC6D0\uAC00\uC785"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                openPolicy && /*#__PURE__*/ (0,jsx_runtime.jsx)(policyModal/* default */.Z, {
                    policy: policyDivision,
                    openPolicyModal: openPolicy,
                    setOpenPolicyModal: showTermsModal
                })
            ]
        })
    });
}
var mapStateToProps = function(state) {
    return {
        banners: state.banners
    };
};
var mapDispatchToProps = {
    openModal: modal/* openModal */.h7,
    modifyModal: modal/* modifyModal */.mn,
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    uidConfirm: common_confirm/* uidConfirm */.RX,
    showToastAlert: action_alert/* showToastAlert */.I,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var register = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(register_Register));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,7533,2511,4027,3685,9135,3130,1839,9774,2888,179], function() { return __webpack_exec__(75511); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);